import styled from 'styled-components'
import { maxQuery } from '../../helpers'

export default styled.div`
  min-height: calc(100vh - ${({ theme }) => theme.navHeight});
  background: linear-gradient(135deg, #1a1d31 0%, #2a2d45 100%);
  padding: 3em 2em;

  ${maxQuery('md')} {
    padding: 2em 1em;
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.1);
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .track-header {
    text-align: center;
    color: #fff;
    margin-bottom: 3em;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 0.5em;
      font-weight: 700;

      ${maxQuery('md')} {
        font-size: 2rem;
      }
    }

    p {
      font-size: 1.1rem;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 2em;
    }

    .search-form {
      max-width: 600px;
      margin: 0 auto;
      display: flex;
      gap: 0.5em;

      ${maxQuery('sm')} {
        flex-direction: column;
      }

      .search-input {
        flex: 1;
        padding: 1em 1.5em;
        border: 2px solid rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        font-size: 1rem;
        font-family: inherit;
        outline: none;
        transition: all 0.3s ease;

        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        &:focus {
          border-color: ${({ theme }) => theme.primary};
          background: rgba(255, 255, 255, 0.15);
        }
      }

      .search-btn {
        padding: 1em 2.5em;
        border: none;
        border-radius: 12px;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        white-space: nowrap;

        &:hover {
          opacity: 0.9;
          transform: translateY(-2px);
        }

        ${maxQuery('sm')} {
          width: 100%;
        }
      }
    }
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    color: #fff;

    .spinner {
      width: 50px;
      height: 50px;
      border: 4px solid rgba(255, 255, 255, 0.2);
      border-top-color: ${({ theme }) => theme.primary};
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    p {
      margin-top: 1em;
      font-size: 1.1rem;
      color: rgba(255, 255, 255, 0.7);
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  }

  .error-container {
    max-width: 600px;
    margin: 3em auto;
    padding: 3em;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    text-align: center;
    color: #fff;

    .error-icon {
      font-size: 4rem;
      margin-bottom: 1em;
    }

    h3 {
      font-size: 1.8rem;
      margin-bottom: 0.5em;
    }

    p {
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 2em;
    }

    .retry-btn {
      padding: 0.8em 2em;
      border: none;
      border-radius: 8px;
      background: ${({ theme }) => theme.primary};
      color: #fff;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .tracking-content {
    max-width: 1400px;
    margin: 0 auto;
  }

  .tracking-grid {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 2em;

    ${maxQuery('lg')} {
      grid-template-columns: 1fr;
    }
  }

  .details-section {
    display: flex;
    flex-direction: column;
    gap: 1.5em;
  }

  .status-card,
  .rider-card,
  .location-card,
  .package-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    padding: 2em;
    backdrop-filter: blur(10px);

    h3 {
      color: #fff;
      font-size: 1.2rem;
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      gap: 0.5em;

      svg {
        font-size: 1.4rem;
      }
    }
  }

  .status-header {
    display: flex;
    align-items: center;
    gap: 1.5em;
    padding-bottom: 1.5em;
    margin-bottom: 1.5em;
    border-bottom: 2px solid;

    .status-icon {
      font-size: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .status-info {
      flex: 1;

      .status-label {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.9rem;
        display: block;
        margin-bottom: 0.3em;
      }

      h2 {
        font-size: 1.8rem;
        margin: 0;
      }
    }
  }

  .order-info {
    .info-row {
      display: flex;
      justify-content: space-between;
      padding: 0.8em 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      &:last-child {
        border-bottom: none;
      }

      .info-label {
        color: rgba(255, 255, 255, 0.6);
      }

      .info-value {
        color: #fff;
        font-weight: 600;
      }
    }
  }

  .rider-details {
    .rider-name {
      display: flex;
      flex-direction: column;
      gap: 0.5em;
      color: #fff;

      strong {
        font-size: 1.1rem;
      }

      .phone-link {
        display: flex;
        align-items: center;
        gap: 0.5em;
        color: ${({ theme }) => theme.primary};
        text-decoration: none;
        font-size: 0.95rem;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .directions-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.5em;
      margin-top: 1em;
      padding: 0.8em 1.5em;
      background: ${({ theme }) => theme.primary};
      color: #fff;
      text-decoration: none;
      border-radius: 8px;
      font-weight: 600;
      font-size: 0.95rem;
      transition: all 0.3s ease;

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(254, 125, 17, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .location-item {
    display: flex;
    gap: 1em;
    margin-bottom: 1em;

    .location-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.3rem;
      flex-shrink: 0;

      &.pickup {
        background: rgba(76, 175, 80, 0.2);
        color: #4caf50;
      }

      &.delivery {
        background: rgba(254, 125, 17, 0.2);
        color: ${({ theme }) => theme.primary};
      }
    }

    .location-info {
      flex: 1;

      .location-label {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.85rem;
        display: block;
        margin-bottom: 0.3em;
      }

      p {
        color: #fff;
        margin: 0.3em 0;
        line-height: 1.5;
      }

      .contact-name {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.9rem;
        display: block;
        margin-top: 0.5em;
      }

      .contact-phone {
        color: ${({ theme }) => theme.primary};
        font-size: 0.9rem;
        display: block;
        margin-top: 0.3em;
      }
    }
  }

  .location-divider {
    width: 2px;
    height: 40px;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 1.2em 1em 1.2em;
  }

  .package-card {
    p {
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.6;
    }

    .package-details {
      margin-top: 1em;
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.9rem;
    }
  }

  .directions-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    padding: 2em;
    backdrop-filter: blur(10px);

    h3 {
      color: #fff;
      font-size: 1.2rem;
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      gap: 0.5em;

      svg {
        font-size: 1.4rem;
      }
    }

    .route-summary {
      display: flex;
      gap: 2em;
      margin-bottom: 1.5em;
      padding-bottom: 1.5em;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      ${maxQuery('sm')} {
        flex-direction: column;
        gap: 1em;
      }

      .route-stat {
        display: flex;
        align-items: center;
        gap: 0.8em;

        .stat-icon {
          font-size: 1.8rem;
        }

        div {
          display: flex;
          flex-direction: column;
          gap: 0.2em;
        }

        .stat-label {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
        }

        .stat-value {
          color: ${({ theme }) => theme.primary};
          font-size: 1.1rem;
          font-weight: 700;
        }
      }
    }

    .directions-list {
      max-height: 400px;
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;

        &:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }

    .direction-step {
      display: flex;
      gap: 1em;
      padding: 0.8em;
      margin-bottom: 0.5em;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.03);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
      }

      .step-icon {
        font-size: 1.5rem;
        min-width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .step-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1em;

        ${maxQuery('sm')} {
          flex-direction: column;
          align-items: flex-start;
          gap: 0.3em;
        }

        .step-instruction {
          color: #fff;
          font-size: 0.95rem;
          line-height: 1.4;

          strong {
            color: ${({ theme }) => theme.primary};
            text-transform: capitalize;
          }
        }

        .step-distance {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
          white-space: nowrap;
        }
      }
    }

    .more-steps {
      text-align: center;
      color: rgba(255, 255, 255, 0.5);
      font-size: 0.9rem;
      padding: 0.8em;
      font-style: italic;
    }
  }

  .map-section {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .map-container {
    height: 600px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

    ${maxQuery('lg')} {
      height: 450px;
    }

    ${maxQuery('md')} {
      height: 350px;
    }

    /* Leaflet map styles */
    .leaflet-container {
      border-radius: 16px;
      background: #1a1d31;
    }

    .leaflet-popup-content-wrapper {
      background: #2a2d45;
      color: #fff;
      border-radius: 8px;
    }

    .leaflet-popup-tip {
      background: #2a2d45;
    }

    .leaflet-control-zoom {
      border: none;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .leaflet-control-zoom a {
      background: #2a2d45;
      color: #fff;
      border: none;
      
      &:hover {
        background: ${({ theme }) => theme.primary};
      }
    }

    .leaflet-control-attribution {
      background: rgba(42, 45, 69, 0.8);
      color: rgba(255, 255, 255, 0.7);
      font-size: 10px;
      
      a {
        color: ${({ theme }) => theme.primary};
      }
    }
  }

  .map-legend {
    display: flex;
    justify-content: center;
    gap: 2em;
    padding: 1em;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;

    ${maxQuery('sm')} {
      flex-direction: column;
      gap: 0.8em;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 0.5em;
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.9rem;

      .legend-marker {
        width: 12px;
        height: 12px;
        border-radius: 50%;

        &.pickup {
          background: #4caf50;
        }

        &.delivery {
          background: ${({ theme }) => theme.primary};
        }

        &.rider {
          background: #2196f3;
        }
      }
    }
  }
`
